export const BTN_TYPE = {
  Submit: 'Submit',
  Save: 'Save',
  Cancel: 'Cancel',
  ConfirmCancel: 'Cancel',
  Back: 'Back',
  Return: 'Return',
  Approve: 'Approve',
  Reject: 'Reject',
  PreviousVersion: 'PreviousVersion',
  Edit: 'Edit',
  Duplicate: 'Copy', //CMN-FN021評分表複製
  Copy: 'Copy',
  Copy2: 'Copy2',
  Release: 'Release',
  FileUpload: 'FileUpload',
  Attachment: 'Attachment',
  Discard: 'Discard',
  CancelReceipt: 'CancelReceipt',
  SupplementInitiation: 'SupplementInitiation',
  SupplementUpload: 'SupplementUpload',
  ViewVersionHistory: 'ViewVersionHistory',
};
export const ENQUIRY_BTN_TYPE = {
  History: 'Version History',
  Exit: 'Exit',
};
